import { AppBar, FormControlLabel, makeStyles, Switch, withStyles } from "@material-ui/core";
import { styled } from "@material-ui/styles";
import { useIO, useModel } from "@type-r/react";
import { Button, Flex, Loading, navigate, Page, PrimaryButton, SelectSortBy, Toolbar } from "lqx-react/lib";
import * as React from "react";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";
import { RowH1, RowH3 } from "../../../../../common";
import { AddFilter } from "../components/search-bar/search-bar";
import { ValidationRulesList } from "./validation-rules-list";
import { ValidationRuleState } from "./models/validation-rules-store";

const sortOptions = {
    createdOn: "Created On",
    updatedOn: "Updated On"
}

export const ValidationRulesPage = () => {
    const classes = useStyles();
    const state = useModel(ValidationRuleState);

    const isReady = useIO(async () => {
        await getData();
        state.initialize()
    }, []);

    const getData = async () => {
        await state.getFiltered(state.mapToQuery())
            .then(async (validationRules) => {
                state.validationCards.set(validationRules.items as any);
            });
    }

    const dataLoaded = useIO(async () => {
        if (isReady) {
            await getData()
        }
    },
        [state.filter['_changeToken'], state.sort['_changeToken']]
    );

    return (
        <Page maxWidth={false} header={
            <Flex center>
                <RowH1 className={classes.title}>Validation Sets</RowH1>
            </Flex>
        }
            top={
                <AppBar position="static" color="secondary">
                    <Toolbar>
                        <StyledFilterBar filter={state.filter} filterAllPlaceholder="Filter by Company Name, Validation Rule Name, or Asset Type" />
                        <SelectSortBy $attr={state.sort.$.attr} $asc={state.sort.$.asc} options={sortOptions} />
                        {Can(UserEntitlementCatalogs.ViewCreateValidationRuleButton) &&
                            <PrimaryButton
                                style={{ marginLeft: "auto" }}
                                onClick={() => navigate("validation-rules/new")}>
                                Create Validation Set
                            </PrimaryButton>
                        }
                    </Toolbar>
                </AppBar>
            }>
            {isReady && dataLoaded ?
                <ValidationRulesList validationCards={state.validationCards}></ValidationRulesList> : <Loading />}
        </Page>);
};

const useStyles = makeStyles({
    title: {
        padding: '20px 0',
        color: '#3d6889',
        fontSize: '24px'
    }
});

const StyledFilterBar = styled(AddFilter)({
    width: '650px',
    alignItems: 'center',
    padding: '4px',
})

const StyledFormControlLabel = withStyles({
    label: {
        fontSize: '13px',
        fontFamily: 'Montserrat',
        fontWeight: 500,
        color: 'grey',
    },
    labelPlacementStart: {
        margin: '0 !important'
    }
})(FormControlLabel)
